import { render } from "./NewMelati.vue?vue&type=template&id=45d00910&scoped=true&ts=true"
import script from "./NewMelati.vue?vue&type=script&lang=ts"
export * from "./NewMelati.vue?vue&type=script&lang=ts"

import "./NewMelati.vue?vue&type=style&index=0&id=45d00910&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d00910"]])

export default __exports__